// extracted by mini-css-extract-plugin
export default {"notesContainer":"Style_notesContainer__oOgif","note":"Style_note__Uej9c","bookingNote":"Style_bookingNote__zaxtA","webCustomerNote":"Style_webCustomerNote__6zjbg"};